import React from 'react';

import { useBeam } from '@randajan/bifrost/client/react';
import { docsBeam } from '../../config/bifrost';
import { usePopRouter } from '../../hooks/usePopRouter';
import { Doc } from './Doc/Doc';

export const usePopDocs = (props)=>{
    
    const { data:docsList, status } = useBeam(docsBeam);

    const docs = Object.fromEntries((docsList || []).map(doc=>[doc.webPath, doc]));

    return usePopRouter("search.cti", docs, doc=><Doc {...doc}/>, status === "ready");
}

